import React, { useContext, useEffect, useState } from "react";
import imgIcon from "../../assets";
import "./ticket.css";
import { Buttons } from "../../common/Buttons";
import { IconDetalis } from "../../common/IconDetalis";
import { LeftRightlayout } from "../Container/LeftRightlayout";
import { buttonClass, Icon } from "../../common/CSS";
import { Header } from "../Container/Header";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getTicketsList } from "../../actions/tickets";
import moment from "moment"; 
import FormContextApi from "../../ContextApi";
import config from "../../config";
import Loader from "../../common/Loder";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import PendingIcon from "@mui/icons-material/Pending";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChatIcon from "@mui/icons-material/Chat";

export default function Ticket() {
  const { setserviceInit } = useContext(FormContextApi);
  const { tickets, ticketsCount } = useSelector(
    (store) => store.ticketsreducer
  );
  const { wallet_applicable } = useSelector((store) => store.userreducer);
  const { ticketTableLoading } = useSelector((store) => store.loadingreducer);
  const [limit, setlimit] = useState(10);
  const { user } = useSelector((store) => store.userreducer);
  const dispatch = useDispatch();
  const navigator = useNavigate();

  useEffect(() => {
      document.title = 'Tickets History';
  }, []);

  useEffect(() => {
    dispatch(
      getTicketsList({
        customerId: user?.customer_id,
        count: true,
        activeTab: "alltickets",
        limit: limit,
      })
    );
  }, [limit, dispatch, user?.customer_id]);

  const viewMoreTicketLimit = () => {
    let value = limit + 10;
    if (value < ticketsCount?.alltickets) {
      setlimit(value);
    } else {
      setlimit(ticketsCount?.alltickets);
    }
  };

  const handleTicketChat = (id) => {
    window.open(
      `${config.ui4Domain}/ccs/chat?conversationId=${id}&type=ticket`,
      "_blank"
    );
  };

  const cloneTickethandler = (describe, city, address, pincode) => {
    setserviceInit({
      pincode: pincode,
      city: city,
      address: address,
      describe: describe,
      date: "",
      document: "",
    });
    navigator("/service");
  };

  const Content = () => {
    return (
      <>
        <Header showButton path="/service" />
        <div className="mt-4 ">
          <div
            className={`${Icon.HeadingIcon} ${
              wallet_applicable && "grid-cols-3"
            }`}
          >
            <IconDetalis
              coloreIcon="text-darkblue"
              IconName="manage_accounts"
              IconHeading="Your Details"
            />
            <IconDetalis
              coloreIcon="text-darkblue"
              IconName="confirmation_number"
              IconHeading="Tickets History"
            />
            {!wallet_applicable && (
              <IconDetalis
                coloreIcon="text-stardust"
                IconName="currency_rupee"
                IconHeading="Payment"
              />
            )}
            <IconDetalis
              coloreIcon="text-stardust"
              IconName="engineering"
              IconHeading="Get Engineer"
            />
            <div className="w-110F rounded-none bg-darkblue h-3P mt-3 checkBox">
              <CheckCircleIcon />
            </div>
            <div className="w-110F rounded-none bg-darkblue h-3P mt-3 checkBoxPanding">
              <PendingIcon />
            </div>
            {!wallet_applicable && (
              <div className="w-110F rounded-none bg-stardust h-3P mt-3"></div>
            )}
            <div className="w-full rounded-none bg-stardust h-3P mt-3"></div>
          </div>
        </div>

        <div className="ticketSecond">
          <h1 className="text-22F mt-6 font-medium ml-9">My Booked Tickets</h1>
          <div className="mt-3 ticketConatiner">
            <ul className=" overflow-scroll " style={{ maxHeight: "36rem" }}>
              {tickets?.map((e) => {
                return (
                  <li key={e?.id} className="border-b-2 py-3 px-2">
                    <div className="flex ml-8 pt-2 items-center justify-items-center mb-2">
                      <p className="material-icons text-17F w-4">
                        {" "}
                        confirmation_number
                      </p>
                      <p className="text-17F ml-2 w-67%">
                        <Tooltip title="Open Chat" placement="bottom" arrow>
                          <span
                            className="cursor-pointer hover:underline hover:decoration-2"
                            onClick={() => {
                              handleTicketChat(e?.id);
                            }}
                          >
                            {e?.job_ticket_number}
                          </span>
                        </Tooltip>
                      </p>
                      <p>
                        <Buttons
                          btnText="Clone Ticket"
                          classN={`${buttonClass?.ticketButton} `}
                          onClick={() => {
                            cloneTickethandler(
                              e?.description,
                              e?.city?.city_name,
                              e?.job_pickup_address_1,
                              e?.job_pickup_fk_pincode_id
                            );
                          }}
                        />
                      </p>
                      <Tooltip title="Open Chat" placement="bottom" arrow>
                        <p
                          className="material-icons text-17F hover:text-scogoOrange cursor-pointer ml-4"
                          onClick={() => {
                            handleTicketChat(e?.id);
                          }}
                        >
                          <ChatIcon className="hover:text-scogoOrange cursor-pointer" />
                        </p>
                      </Tooltip>
                    </div>
                    <div>
                      <span className="ml-8 bg-scogoBgBrop text-12F p-1 rounded mt-6">
                        Create At : {moment(e?.created_at).format("MMM/D/YYYY")}
                      </span>
                      <span
                        className={`ml-4 text-12F p-1  ${e?.ticket_status?.style}  rounded`}
                      >
                        Status: {e?.ticket_status?.status}
                      </span>
                    </div>
                    <div className="flex items-center">
                      <div className="mt-4 ml-8 pl-2 py-1 w-5/6 border-slate-800 border-l-2 text-16F overflow-hidden ">
                        {e?.job_pickup_address_1}, {e?.job_pickup_fk_pincode_id}
                      </div>
                    </div>
                  </li>
                );
              })}
              {ticketTableLoading ? (
                <div className="mt-3">
                  <Loader speed="1" thickness="4" size="30" />
                </div>
              ) : null}

              {limit !== ticketsCount?.alltickets &&
              !ticketTableLoading &&
              tickets?.length !== ticketsCount?.alltickets ? (
                <div className="text-right mt-2 mb-4  text-lg mr-4">
                  <span
                    className="cursor-pointer hover:underline hover:decoration-2"
                    onClick={() => {
                      viewMoreTicketLimit();
                    }}
                  >
                    {" "}
                    View more...
                  </span>
                </div>
              ) : null}
            </ul>
          </div>

          <div className="w-full m-auto text-center mt-4 pb-2">
            <Buttons
              btnText="Go to Portal"
              classN={`${buttonClass?.scogoPrimary} w-43% mr-6 pt-2 pb-2 `}
              Iconafter={
                <Tooltip
                  title={
                    <div className="text-17F">
                      Invite users or create bulk Tickets
                    </div>
                  }
                  placement="top-start"
                  className="Tooltip"
                  arrow
                >
                  <IconButton>
                    <HelpOutlineIcon className="text-white text-1rem" />
                  </IconButton>
                </Tooltip>
              }
              onClick={() => {
                window.open(config?.portal, "_blank");
              }}
            />
            <Buttons
              btnText="Book Ticket"
              classN={`${buttonClass?.scogoOrange} w-43%  rounded-md pt-2 pb-2 `}
              onClick={() => {
                navigator("/service");
              }}
            />
          </div>
        </div>
      </>
    );
  };

  const rightSection = () => {
    return (
      <>
        <div className="m-auto h-5/6 w-68P">
          <img
            width="100%"
            className="m-auto h-5/6 mt-8"
            src={imgIcon.ticketimg}
            alt=""
          />
        </div>
      </>
    );
  };

  return <LeftRightlayout Content={Content} RightImg={rightSection} />;
}
